import { useEffect, useState } from "react";

export default function BookingSuccessToast() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    if (p.get("success") === "1") {
      setShow(true);
      p.delete("success");
      const clean = `${window.location.pathname}${p.toString() ? "?" + p.toString() : ""}`;
      window.history.replaceState({}, "", clean);

      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-start justify-center p-4">
      <div className="mt-6 w-full max-w-md rounded-2xl shadow-xl border bg-white/90 backdrop-blur p-4">
        <h2 className="text-base font-semibold mb-1">Buchung erfolgreich 🎾</h2>
        <p className="text-sm text-gray-700">
          Du erhältst gleich eine Bestätigungs-E-Mail. Viel Spaß beim Spielen!
        </p>
        <div className="mt-3 flex gap-2">
          <button
            onClick={() => setShow(false)}
            className="px-3 py-2 rounded-lg bg-red-600 text-white text-sm font-medium hover:bg-red-700 transition-colors"
          >
            Verstanden
          </button>
        </div>
      </div>
    </div>
  );
}
